module.exports = __webpack_public_path__ + "img/testcomplete.99afed3f.png";